export default {
  userInfo: state => state.userInfo,
  token: state => state.token,
  isLogin: state => state.token !== '',
  PackageAttribute: state => state.PackageAttribute
}
